"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsForUser = exports.PermissionDetailsDto = exports.Role = exports.stringToPermission = exports.Permission = void 0;
const swagger_proxy_1 = require("./swagger-proxy");
const class_validator_proxy_1 = require("./class-validator-proxy");
// This is the authoritative list of all permissions that can be assigned to users.
var Permission;
(function (Permission) {
    // NOC only permissions
    Permission["READ_NOC"] = "read:noc";
    Permission["WRITE_NOC"] = "write:noc";
    Permission["WRITE_NOC_USERS"] = "write:noc-users";
    Permission["CHANGE_SITE_RELATIONSHIPS"] = "write:change-site-relationships";
    Permission["READ_NOC_USERS"] = "read:noc-users";
    Permission["OCPI_ADMIN"] = "write:ocpi-admin";
    // General user permissions
    Permission["READ_GENERAL"] = "read:general";
    Permission["WRITE_GENERAL"] = "write:general";
    Permission["READ_USERS"] = "read:users";
    Permission["WRITE_USERS"] = "write:users";
    Permission["AUTHORIZE_PAYMENT"] = "write:authorize-payment";
    Permission["READ_PRICING"] = "read:pricing";
    Permission["WRITE_PRICING"] = "write:pricing";
    Permission["READ_SITE_SETTINGS"] = "read:site-settings";
    Permission["WRITE_SITE_SETTINGS"] = "write:site-settings";
    Permission["READ_POWER_TRACE"] = "read:power-trace";
    Permission["READ_REPORTS"] = "read:reports";
    Permission["READ_TRANSACTION_LOGS"] = "read:transaction-logs";
})(Permission = exports.Permission || (exports.Permission = {}));
// Converts a permission string to a Permission enum value
// throws if the string does not match any Permission enum value
function stringToPermission(str) {
    const p = Object.values(Permission).includes(str)
        ? str
        : undefined;
    if (p === undefined) {
        throw new Error(`Permission ${str} is not a valid permission`);
    }
    return p;
}
exports.stringToPermission = stringToPermission;
// DTO object for role
class Role {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Unique role identifier",
        example: "admin",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], Role.prototype, "id", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Human-readable role name",
        example: "Administrator",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], Role.prototype, "name", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Detailed description of the role",
        example: "Full administrative access to all features",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], Role.prototype, "description", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Array of permissions granted by this role",
        enum: Permission,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsEnum)(Permission, { each: true }),
    __metadata("design:type", Array)
], Role.prototype, "permissions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether this is a NOC (Network Operations Center) role that can only be adopted by users in the NOC",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], Role.prototype, "isNoc", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Whether this role can only be assigned to other users by NOC users",
        example: false,
        type: Boolean,
    }),
    (0, class_validator_proxy_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], Role.prototype, "isAssignableByNocOnly", void 0);
exports.Role = Role;
class PermissionDetailsDto {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Permission identifier",
        enum: Permission,
    }),
    (0, class_validator_proxy_1.IsEnum)(Permission),
    __metadata("design:type", String)
], PermissionDetailsDto.prototype, "id", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Human-readable permission description",
        example: "Read general organization information",
        type: String,
    }),
    (0, class_validator_proxy_1.IsString)(),
    __metadata("design:type", String)
], PermissionDetailsDto.prototype, "description", void 0);
exports.PermissionDetailsDto = PermissionDetailsDto;
class PermissionsForUser {
}
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Organization-level permissions for the user",
        enum: Permission,
        isArray: true,
    }),
    (0, class_validator_proxy_1.IsArray)(),
    (0, class_validator_proxy_1.IsEnum)(Permission, { each: true }),
    __metadata("design:type", Array)
], PermissionsForUser.prototype, "permissions", void 0);
__decorate([
    (0, swagger_proxy_1.ApiProperty)({
        description: "Site-specific permissions mapped by site ID",
        type: Object,
        additionalProperties: {
            type: "array",
            items: { enum: Object.values(Permission) },
        },
    }),
    (0, class_validator_proxy_1.IsObject)(),
    __metadata("design:type", Object)
], PermissionsForUser.prototype, "siteSpecificPermissions", void 0);
exports.PermissionsForUser = PermissionsForUser;
